import React, { useCallback, useState } from 'react';
import { Modal, Button, Slider } from 'antd';
import Cropper, { Area, Point } from 'react-easy-crop';

interface IComponentProps {
  open: boolean;
  imageSrc: string;
  aspectRatio: number;
  onCancel: () => void;
  onConfirm: (cropPixels: Area) => void;
}

export const ImageCropModal: React.FC<IComponentProps> = ({ open, imageSrc, aspectRatio, onCancel, onConfirm }) => {
  const [crop, setCrop] = useState<Point>({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<Area | null>(null);

  const handleCropComplete = useCallback((_croppedArea: Area, pixels: Area) => {
    setCroppedAreaPixels(pixels);
  }, []);

  const handleConfirm = () => {
    if (croppedAreaPixels) {
      onConfirm(croppedAreaPixels);
    }
  };

  return (
    <Modal
      title="Crop image to fit required proportions"
      open={open}
      onCancel={onCancel}
      maskClosable={false}
      width={520}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Cancel
        </Button>,
        <Button key="confirm" type="primary" onClick={handleConfirm}>
          Apply
        </Button>,
      ]}
    >
      <div style={{ position: 'relative', width: '100%', height: 360, background: '#333' }}>
        <Cropper
          image={imageSrc}
          crop={crop}
          zoom={zoom}
          aspect={aspectRatio}
          onCropChange={setCrop}
          onZoomChange={setZoom}
          onCropComplete={handleCropComplete}
        />
      </div>
      <Slider min={1} max={3} step={0.1} value={zoom} onChange={setZoom} className="mt-4" />
    </Modal>
  );
};
